import React from 'react'

type SpinnerProps = {
  contained?: boolean
  inline?: boolean
  size?: number
}

function Spinner({ contained, inline, size }: SpinnerProps) {
  const sizeStyle = size ? { width: size, height: size } : undefined

  if (inline) {
    return <div className="spinner" style={sizeStyle} />
  }

  return (
    <div className={`spinner-container${contained ? ' contained' : ''}`}>
      <div className="spinner" style={sizeStyle} />
    </div>
  )
}

export default Spinner
